import { Injectable } from "@angular/core";
@Injectable()
export class FormValidator {

  //check is there any data
  validateIsData(data) {
    return !!(data && data.replace(/\s/g, '').length != 0);
  }

  //validate email address
  validateIsEmail(email) {
    if (email) {
      let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    }
    else return false;
  }
  validateIsDataForNumber(data) {
    return !(data == null || data == "" || data == undefined);
  }

  // Validate Name
  validateName(name) {
    return !!/^[a-z0-9][a-z0-9._\-]*$/.exec(name);
  }
  validateForName(name) {
    return !!/^[a-zA-Z\s]+$/;
  }

  //validate date in yyyy-mm-dd format
  isValidDate(dateString) {
    let regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) != null;
  }

  //validate date in dd/mm/yyyy format
  isValidDateStr(strDate) {
    let myDateStr = new Date(strDate);
    return !isNaN(myDateStr.getMonth());

  }
  validateIsDataForString(data) {
    return !(data == null || data == "" || data == undefined);
  }

  validateMobileNumber(mobileNumber) {
    let pattern = /^[7-9][0-9]{9}$/;
    return pattern.test(mobileNumber);
  }
  validateOnlyMobileNumber(mobileNumber) {
    let pattern = /^[0-9]{10}$/;
    return pattern.test(mobileNumber);
  }
  validateMobileNumberForNewAdmission(string, mobileNumber) {
    if (!mobileNumber) {
      return "Please enter " + string.toLowerCase() + " mobile number";

    }
    if (!/^\d+$/.test(mobileNumber)) {
      return "Enter only numbers";
    }
    if (/^0/.test(mobileNumber)) {
      return string + " mobile number should not start with zero";
    } 
    return false;
  }
  validateAadharNumber(aadharNum) {
    if (!/^[0-9]{12}$/.test(aadharNum)) {
      return "Aadhar number should be 12 digits.";
    }
    return false;
  }
  IsNumForContNum(mobileCode) {
    let pattern = mobileCode;
    return !isNaN(pattern);
  }

  validateDropdownData(data) {
    return data == "undefined" ? false : true;
  }

  validateFieldName(studentName, string) {
    const regex = /^[^-].*/;
    if (!studentName) {
      return string + ' name cannot be empty.';
    }
    // if (/^\d/.test(studentName)) {
    //   return string + ' name cannot start with a number.';
    // }
    if (!regex.test(studentName)) {
      return string + 'name cannot be a negative value.';
    }
    return null;
  }

  valdateDOB(date) {
    const [day, month, year] = date.split('/');
    const formattedDate = `${month}/${day}/${year}`;
    const selectedDate = new Date(formattedDate);
    const ageInMilliseconds = Date.now() - selectedDate.getTime();
    const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
    if (ageInYears < 2) {
      return `Student should be at least 2 years old.`
    } else {
      return null
    }
  }
  validateBusInfoFields(value, string) {
    const regex = /^[^-].*/;
    if (!value) {
      return string + ' cannot be empty.';
    }
    if (!regex.test(value)) {
      return string + 'cannot be a negative value.';
    }
    return null
  }

  validateStaffDOB(date) {
    if (date) {
      const [day, month, year] = date.split('/');
      const formattedDate = `${month}/${day}/${year}`;
      const selectedDate = new Date(formattedDate);
      const ageInMilliseconds = Date.now() - selectedDate.getTime();
      const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
      if (ageInYears < 20) {
        return `Staff should be at least 20 years old.`
      } else {
        return null
      }
    } else {
      return `Please enter date of birth!`
    }
  }

  validateDates(dateOfBirth, dateOfJoining) {
    if (dateOfBirth && dateOfJoining) {
      const dobFormatted = convertToDateObject(dateOfBirth);
      const dojFormatted = convertToDateObject(dateOfJoining);
      const staffDOB = new Date(dobFormatted)
      const staffJoiningDate = new Date(dojFormatted)
      if (staffDOB && staffJoiningDate && staffJoiningDate <= staffDOB && staffJoiningDate <= staffDOB) {
        return "Joining date should be after staff date of birth !"
      } else {
        return null
      }
    }
    return null
  }
  validatePenNumber(number) {
    console.log("number", number, number.length);

  }

}
function convertToDateObject(dateString) {
  const parts = dateString.split('/');
  if (parts.length === 3) {
    return parts[2] + '-' + parts[1] + '-' + parts[0];
  } else {
    return null;
  }
}